import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { createElement } from 'react';
import { CreateSVG } from "../lib/index.js";
function SvgIconTrain(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/createElement(CreateSVG, _objectSpread(_objectSpread({}, props), {}, {
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement("svg", _extends({
        id: "Icon-train_svg__filled",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        "aria-labelledby": titleId
      }, props), title ? /*#__PURE__*/React.createElement("title", {
        id: titleId
      }, title) : null, /*#__PURE__*/React.createElement("path", {
        d: "M30,5a1,1,0,0,1-.6-.2L26,2.25,22.6,4.8a1,1,0,0,1-1.2-1.6l4-3a1,1,0,0,1,1.2,0l4,3a1,1,0,0,1,.2,1.4A1,1,0,0,1,30,5Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M36,8H16a6,6,0,0,0-6,6V30a16,16,0,0,0,32,0V14A6,6,0,0,0,36,8ZM19,38a2,2,0,1,1,2-2A2,2,0,0,1,19,38Zm15,0a2,2,0,1,1,2-2A2,2,0,0,1,34,38ZM26.76,27H25.24A11.25,11.25,0,0,1,14,15.76,3.77,3.77,0,0,1,17.76,12h7.78l-6.3,7.35a1,1,0,0,0,1.52,1.3L28.17,12h6.07A3.77,3.77,0,0,1,38,15.76,11.25,11.25,0,0,1,26.76,27Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M11.8,48l-1.63,2.45a1,1,0,0,0,.28,1.38A.94.94,0,0,0,11,52a1,1,0,0,0,.83-.45l1-1.55H39.13l1,1.55A1,1,0,0,0,41,52a.94.94,0,0,0,.55-.17,1,1,0,0,0,.28-1.38L40.2,48Z"
      }));
    }
  }));
}
export default SvgIconTrain;